
var fs = require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/virtual-fs.js");
var _ctxMap = {
  "./Courier-Bold.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Courier-Bold.afm"),
  "./Courier-BoldOblique.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Courier-BoldOblique.afm"),
  "./Courier-Oblique.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Courier-Oblique.afm"),
  "./Courier.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Courier.afm"),
  "./Helvetica-Bold.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Helvetica-Bold.afm"),
  "./Helvetica-BoldOblique.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Helvetica-BoldOblique.afm"),
  "./Helvetica-Oblique.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Helvetica-Oblique.afm"),
  "./Helvetica.afm": require("/home/runner/work/vets-website/vets-website/src/platform/pdf/node_modules/pdfkit/js/data/Helvetica.afm")
};
function _ctx(key) { return _ctxMap[key]; }
_ctx.keys = function() { return Object.keys(_ctxMap); };
function registerAFMFonts(ctx) {
  ctx.keys().forEach(function(key) {
    var match = key.match(/([^/]*\.afm$)/);
    if (match) { fs.writeFileSync("data/" + match[0], ctx(key)); }
  });
}
if (process.env.NODE_ENV !== 'test') { registerAFMFonts(_ctx); }
